import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../config/endpoints";
import axiosConfig from "../../../utils/axiosConfig";

const initialState = {
  loading: false,
  onboardingDetails: null,
  error: null
};

export const getOnboardingDetails = createAsyncThunk(
  "onboardingDetails/fetch",
  async (args) => {
    return axiosConfig(
      `${endpoints.onboardingDetails}?pre_customer_id=${args?.precustomerId}`
    );
  }
);

const onboardingDetailsSlice = createSlice({
  name: "onboardingDetails",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(getOnboardingDetails.pending, (state) => {
      state.loading = true;
      state.onboardingDetails = null;
    });
    builder.addCase(getOnboardingDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.onboardingDetails = action.payload;
      state.error = "";

      console.log(action?.payload);
    });
    builder.addCase(getOnboardingDetails.rejected, (state, action) => {
      state.loading = false;
      state.onboardingDetails = {};
      state.error = "Error, Failed to load";
    });
  },
});

export default onboardingDetailsSlice.reducer;

